(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadParameterDialogController', LeadParameterDialogController);

    LeadParameterDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LeadParameter'];

    function LeadParameterDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LeadParameter) {
        var vm = this;
        vm.leadParameter = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:leadParameterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.leadParameter.id !== null) {
                LeadParameter.update(vm.leadParameter, onSaveSuccess, onSaveError);
            } else {
                LeadParameter.save(vm.leadParameter, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
